import type { Time } from "@suse-o11y/date-time/time";
import type { Destructor } from "@suse-o11y/destructor";
import { max } from "@suse-o11y/max";

/**
 * Executes a callback function after a specified delay.
 *
 * @param callback - The callback function to be executed.
 * @param timeout - The delay in milliseconds before the callback is executed.
 *
 * @returns A cleanup function that can be used to cancel the timeout.
 */
export function onTimeout(callback: (now: Time) => void, timeout: number): Destructor {
	// biome-ignore lint/style/noRestrictedGlobals: encapsulation
	const timeoutId = window.setTimeout(() => callback(Date.now()), max(0, timeout));

	// biome-ignore lint/style/noRestrictedGlobals: encapsulation
	return () => window.clearTimeout(timeoutId);
}
